import React from 'react';
import './style.scss';
import Chart from 'react-apexcharts';

const ChartCuston = ({
  data,
  margin
}) => {

  return <div style={{ position: "relative", height: "100%" }}>
    <Chart
      options={{
        legend: {
          show: true,
          position: 'right',
          horizontalAlign: 'right',
          floating: false,
          fontSize: '12px',
          itemMargin: {
            horizontal: margin,
            vertical: 0
          },
          width: 200
        },
        noData: {
          text: data.load ? 'Carregando...' : 'Sem dados'
        },
        yaxis: {
          labels: {
            formatter: function (d) {
              return d
                ? 'R$ ' +
                d.toLocaleString("pt-br", {
                  minimumFractionDigits: 2,
                })
                : '';
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              yaxis: {
                labels: {
                  formatter: function (d) {
                    const nome=(valor)=>{
                      switch (valor.split('.').length) {
                        case 2:
                          return 'mil'
                          break;
                        case 3:
                          return 'mi'
                          break;
                        case 4:
                          return 'bi'
                          break;
                        default:
                          return ''
                          break;
                      }
                    }
                    let valor = d?d.toLocaleString("pt-br", {
                      minimumFractionDigits: 2,
                    }):'';
                    return valor
                      ? 'R$ ' +
                        valor.split('.')[0]+' '+(nome(valor))
                      : '';
                  },
                },
              },
            },
          },
        ],
        labels: data.names,
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150,
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350,
          },
        },
        // tooltip: {
        //   custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        //     return '<div style="padding:5px">' +
        //       "<b>" + w.config.labels[seriesIndex] + ": </b>" +
        //       "<spam>" +
        //       parseFloat(series[seriesIndex]).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) +
        //       "</spam>" +
        //       "</div>";
        //   }
        // }
      }}
      series={[{
        name:"Valor",
        type: 'column',
        data: data.values
      }]}
      type="line"
    />
  </div>
};

export default ChartCuston;
